import {useRouter} from 'next/router';
import {cn} from '../../../../../../lib/classname';
import {CommonLink} from '../../../../../../shared/components/CommonLink';

export type TabMenuItem = {
  icon: React.ReactNode;
  label: string;
  url: string;
  isExternal?: boolean;
};

export const TabMenu: React.FC<{menu: TabMenuItem[]}> = ({menu}) => {
  const router = useRouter();

  return (
    <div className="bg-white py-16 rounded-16 shadow-nav hidden pc:block">
      <div className="flex items-center justify-center gap-36">
        {menu.map((item) => (
          <CommonLink
            key={item.label}
            className={cn(
              'flex flex-col items-center text-sm font-bold text-black-2 cursor-pointer hover:opacity-60',
              item.url === router.asPath ? 'text-primary-1' : 'text-black-2',
            )}
            href={item.url}
            target={item.isExternal ? '_blank' : undefined}
            rel={item.isExternal ? 'noopener noreferrer' : undefined}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </CommonLink>
        ))}
      </div>
    </div>
  );
};
